import { SendStatus } from '@/shared/modules/wallet/send/send-state';

import { type SendFlowViewModel } from './use-send-flow';

export enum SendFlowView {
  Verification = 'verification',
  Suggestion = 'suggestion',
  Processing = 'processing',
  Success = 'success',
  Uncertain = 'uncertain',
  Locked = 'locked',
  Failed = 'failed',
  Confirmation = 'confirmation',
  Form = 'form',
}

export enum SendPageLayout {
  Verification = 'verification',
  Status = 'status',
  Form = 'form',
}

interface SendFlowViewInput {
  verificationOpen: boolean;
  suggestionOpen: boolean;
  isUnlocked: boolean;
  flow: Pick<SendFlowViewModel, 'isBusy' | 'status' | 'confirming'>;
}

const STATUS_SCREEN_STATUSES = new Set([
  SendStatus.SUCCESS,
  SendStatus.ERROR,
  SendStatus.UNCERTAIN,
]);

export function resolveSendFlowView(input: SendFlowViewInput): SendFlowView {
  const { flow } = input;

  if (input.verificationOpen) {
    return SendFlowView.Verification;
  }

  if (input.suggestionOpen) {
    return SendFlowView.Suggestion;
  }

  if (flow.isBusy) {
    return SendFlowView.Processing;
  }

  if (flow.status === SendStatus.SUCCESS) {
    return SendFlowView.Success;
  }

  if (flow.status === SendStatus.UNCERTAIN) {
    return SendFlowView.Uncertain;
  }

  if (!input.isUnlocked) {
    return SendFlowView.Locked;
  }

  if (flow.status === SendStatus.ERROR) {
    return SendFlowView.Failed;
  }

  return flow.confirming ? SendFlowView.Confirmation : SendFlowView.Form;
}

export function resolveSendPageLayout(
  view: SendFlowView,
  flow: Pick<SendFlowViewModel, 'isBusy' | 'status'>,
): SendPageLayout {
  if (view === SendFlowView.Verification) {
    return SendPageLayout.Verification;
  }

  if (flow.isBusy || STATUS_SCREEN_STATUSES.has(flow.status)) {
    return SendPageLayout.Status;
  }

  return SendPageLayout.Form;
}
